import React from 'react'
import { __, sprintf } from 'StylistParent/i18n'

/* Import CSS */
import './index.scss'

class FullScreenToggle extends React.Component {
	constructor( props ) {
		super( props )

		this.buttonTextDefault = __( "Enable Full Screen" )
		this.buttonTextOpened = __( "Exit Full Screen" )

		this.iconPathDefault = "M3 15.6L3 12C3 11.5 2.6 11 2 11 1.5 11 1 11.5 1 12L1 18C1 18.1 1 18.3 1.1 18.4 1.1 18.5 1.2 18.6 1.2 18.7 1.2 18.7 1.2 18.7 1.3 18.7 1.3 18.7 1.3 18.7 1.3 18.7 1.3 18.8 1.3 18.8 1.3 18.8 1.4 18.8 1.5 18.9 1.6 18.9 1.7 19 1.8 19 2 19L2 19 8 19C8.5 19 9 18.6 9 18 9 17.5 8.5 17 8 17L4.4 17 8.7 12.7C9.1 12.3 9.1 11.7 8.7 11.3 8.3 10.9 7.7 10.9 7.3 11.3L3 15.6ZM19 1.9C19 1.8 19 1.7 18.9 1.6 18.9 1.5 18.8 1.4 18.8 1.4 18.8 1.3 18.8 1.3 18.8 1.3 18.7 1.3 18.7 1.3 18.7 1.3 18.7 1.3 18.7 1.3 18.7 1.3 18.6 1.2 18.5 1.1 18.4 1.1 18.3 1.1 18.2 1 18.1 1L18.1 1 18 1 12 1C11.5 1 11 1.5 11 2 11 2.6 11.5 3 12 3L15.6 3 11.3 7.3C10.9 7.7 10.9 8.3 11.3 8.7 11.5 8.9 11.8 9 12 9 12.3 9 12.5 8.9 12.7 8.7L17 4.4 17 8C17 8.6 17.5 9 18 9 18.6 9 19 8.6 19 8L19 2 19 2C19 1.9 19 1.9 19 1.9Z"
		this.iconPathOpened = "M7 14.4L2.7 18.7C2.3 19.1 1.7 19.1 1.3 18.7 0.9 18.3 0.9 17.7 1.3 17.3L5.6 13 2 13C1.5 13 1 12.6 1 12 1 11.5 1.5 11 2 11L8 11 8 11C8.2 11 8.3 11 8.4 11.1 8.5 11.1 8.6 11.2 8.7 11.2 8.7 11.2 8.7 11.2 8.7 11.3 8.7 11.3 8.7 11.3 8.7 11.3 8.8 11.3 8.8 11.3 8.8 11.4 8.8 11.4 8.9 11.5 8.9 11.6 9 11.7 9 11.9 9 12L9 18C9 18.6 8.5 19 8 19 7.4 19 7 18.6 7 18L7 14.4ZM11 8.1C11 8.1 11 8.1 11 8.1L11 8 11 2C11 1.5 11.5 1 12 1 12.6 1 13 1.5 13 2L13 5.6 17.3 1.3C17.5 1.1 17.7 1 18 1 18.3 1 18.5 1.1 18.7 1.3 19.1 1.7 19.1 2.3 18.7 2.7L14.4 7 18 7C18.6 7 19 7.5 19 8 19 8.6 18.6 9 18 9L12 9 12 9 11.9 9C11.8 9 11.7 9 11.6 9 11.5 8.9 11.4 8.9 11.4 8.8 11.3 8.8 11.3 8.8 11.3 8.8 11.3 8.8 11.3 8.7 11.3 8.7 11.3 8.7 11.3 8.7 11.2 8.7 11.2 8.6 11.1 8.5 11.1 8.4 11 8.3 11 8.2 11 8.1Z"

		this.state = {
			buttonText: this.buttonTextDefault,
			iconPath: this.iconPathDefault,
		}
	}

	onFullScreenToggle = ( e, ref ) => {
		e.preventDefault();

		this.props.onFullScreenToggle()

		/* this.setState( prevState => ( {
			isFullScreen: ! prevState.isFullScreen
		} )) */


		const elem = document.documentElement;
		// Check if the FullScreen already active?
		if ( ( document.fullScreenElement !== undefined && document.fullScreenElement === null ) ||
			( document.msFullscreenElement !== undefined && document.msFullscreenElement === null ) ||
			( document.mozFullScreen !== undefined && ! document.mozFullScreen ) ||
			( document.webkitIsFullScreen !== undefined && ! document.webkitIsFullScreen ) ) {
			// Activate Full Screen View.
			if ( elem.requestFullScreen ) {
				elem.requestFullScreen();
			} else if ( elem.mozRequestFullScreen ) {
				elem.mozRequestFullScreen();
			} else if ( elem.webkitRequestFullScreen ) {
				elem.webkitRequestFullScreen( Element.ALLOW_KEYBOARD_INPUT );
			} else if ( elem.msRequestFullscreen ) {
				elem.msRequestFullscreen();
			}

			document.body.classList.add('stlst-fullscreen');
			setTimeout( function() {
				window.stlst_legacy.draw_responsive_handle();
			}, 250 );
		} else {
			// Disable Full Screen View.
			if ( document.cancelFullScreen ) {
				document.cancelFullScreen();
			} else if ( document.mozCancelFullScreen ) {
				document.mozCancelFullScreen();
			} else if ( document.webkitCancelFullScreen ) {
				document.webkitCancelFullScreen();
			} else if ( document.msExitFullscreen ) {
				document.msExitFullscreen();
			}

			document.body.classList.remove('stlst-fullscreen');

			setTimeout( function() {
				window.stlst_legacy.draw_responsive_handle(); 
			}, 250 );
		}
	}

	udpateBodyClass = ( e ) => {
		const state = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
		const event = state ? 'FullscreenOn' : 'FullscreenOff';

		if ( event == 'FullscreenOff' ) {
			body.removeClass( "stlst-fullscreen" );
		}

		if ( event == 'FullscreenOn' ) {
			body.addClass( "stlst-fullscreen" );
		}
	}

	componentWillReceiveProps = ( nextProps ) => {
		this.updateState( nextProps.isFullScreen )
	}

	componentWillMount = () => {
		this.updateState( this.props.isFullScreen )
	}

	updateState = ( isFullScreen ) => {
		// Update button text and icon based on FullScreen property value.
		let newButtonText = this.buttonTextDefault
		let newIconPath = this.iconPathDefault

		if ( isFullScreen ) {
			newButtonText = this.buttonTextOpened
			newIconPath = this.iconPathOpened
		}

		this.setState( {
			buttonText: newButtonText,
			iconPath: newIconPath,
		} )
	}

	componentDidMount() {
		window.addEventListener( 'webkitfullscreenchange mozfullscreenchange fullscreenchange', this.udpateBodyClass.bind( this ) );
	}
	componentWillUnmount() {
		window.removeEventListener( 'webkitfullscreenchange mozfullscreenchange fullscreenchange', this.udpateBodyClass.bind( this ) );
	}

	render() {
		return (
			<button type="button" aria-label="Full-screen"
				className="fullscreen-btn stlst-components-button stlst-components-icon-button"
				onClick={this.onFullScreenToggle}
				data-active={ this.props.isFullScreen }
			><svg aria-hidden="true" role="img" focusable="false" className="dashicon dashicons-admin-generic" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d={this.state.iconPath} /></svg> { this.state.buttonText }</button>
		)
	}
}

export default FullScreenToggle;



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/fullscreen-toggle/index.jsx